import { tokens } from "vue-the-mask";

// Since IN RFB 2.229/2024 a CNPJ may carry letters in its first 12 characters,
// so those positions accept alphanumerics and are upper-cased on input. The two
// check digits stay numeric.
export const taxIdTokens = {
  ...tokens,
  U: {
    pattern: /[0-9a-zA-Z]/,
    transform: (v) => v.toLocaleUpperCase(),
  },
};

export const CPF_MASK = "###.###.###-##";
export const CNPJ_MASK = "UU.UUU.UUU/UUUU-##";
